import { render } from "./ParnasWeddingPlatinum_2026.vue?vue&type=template&id=9bcb1450"
const script = {}

import exportComponent from "/Users/taesungkim/Git/parnas-app-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__